<template>
  <div>
    <vxe-table
      align="center"
      border
      resizable
      show-overflow
      ref="xTable"
      min-height="214"
      :data="tableData1"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @edit-actived="editActivedEvent">
      <vxe-column type="checkbox" width="50"></vxe-column>
      <vxe-column type="seq" width="55"></vxe-column>
      <vxe-column field="year" title="年份" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatRole(row.year, yearList) }}</span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.year" clearable transfer @change="roleChangeEvent">
            <vxe-option v-for="item in yearList" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="postName" title="岗位名称" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatRole(row.postName, roleList1) }}</span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.postName" clearable transfer @change="roleChangeEvent">
            <vxe-option v-for="item in roleList1" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="otherPost" title="其他岗位" :edit-render="{}">
        <template #edit="{ row }">
          <!-- <vxe-textarea v-model="row.otherPost" :autosize="{ minRows: 2, maxRows: 4 }"></vxe-textarea> -->
          <vxe-input v-model="row.otherPost" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="isKeyPosition" title="是否为核心关键岗位" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatRole(row.isKeyPosition, roleList2) }}</span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.isKeyPosition" clearable transfer @change="roleChangeEvent">
            <vxe-option v-for="item in roleList2" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="postType" title="岗位类别" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatRole(row.postType, roleList3) }}</span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.postType" clearable transfer @change="roleChangeEvent">
            <vxe-option v-for="item in roleList3" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="requirements" title="岗位要求" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-input v-model="row.requirements" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="educationalRequirements" title="学历要求" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatRole(row.educationalRequirements, roleList4) }}</span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.educationalRequirements" clearable transfer @change="roleChangeEvent">
            <vxe-option v-for="item in roleList4" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="disciplineSpecialty" title="学科专业" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-input v-model="row.disciplineSpecialty" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-colgroup title="需求数量">
        <vxe-column field="freshGraduate" title="应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.freshGraduate" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="nonFreshGraduate" title="非应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.nonFreshGraduate" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-colgroup title="本省实际招录人数">
        <vxe-column field="provinceFresh" title="应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.provinceFresh" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="provinceNoFresh" title="非应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.provinceNoFresh" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-colgroup title="外省实际招录人数">
        <vxe-column field="othersProvinceFresh" title="应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.othersProvinceFresh" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="othersProvinceNoFresh" title="非应届毕业生" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.othersProvinceNoFresh" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-column field="remark" title="备注" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-input v-model="row.remark" type="text"></vxe-input>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-toolbar>
      <template #buttons>
        <vxe-button @click="insertEvent()">新增</vxe-button>
        <vxe-button @click="$refs.xTable.removeCheckboxRow()">删除选中</vxe-button>
      </template>
    </vxe-toolbar>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'surveItem2',
  components: {},
  data() {
    return {
      tableData1: [{}],
      // roleList1: [
      //   { label: '仿真应用工程师', value: '仿真应用工程师', disabled: false },
      //   { label: '机械工程师', value: '机械工程师', disabled: false },
      //   { label: 'PLC工程师', value: 'PLC工程师', disabled: false },
      //   { label: '自动化工程师', value: '自动化工程师', disabled: false },
      //   { label: '工业机器人工程师', value: '工业机器人工程师', disabled: false },
      //   { label: '工控系统工程师', value: '工控系统工程师', disabled: false },
      //   { label: '仪器仪表工程师', value: '仪器仪表工程师', disabled: false },
      //   { label: '运维工程师', value: '运维工程师', disabled: false },
      //   { label: '其他', value: '其他', disabled: false },
      // ],
      roleList2: [
        { label: '是', value: '1', disabled: false },
        { label: '否', value: '2', disabled: false },
      ],
      roleList3: [
        { label: '研发类', value: '研发类', disabled: false },
        { label: '生产类', value: '生产类', disabled: false },
        { label: '实施类', value: '实施类', disabled: false },
        { label: '运维类', value: '运维类', disabled: false },
        { label: '其他', value: '其他', disabled: false },
      ],
      roleList4: [
        { label: '博士', value: '博士', disabled: false },
        { label: '硕士', value: '硕士', disabled: false },
        { label: '本科', value: '本科', disabled: false },
        { label: '专科及专科以下', value: '专科及专科以下', disabled: false },
      ],
      yearList: [
        { label: '2021', value: '2021', disabled: false },
        { label: '2022', value: '2022', disabled: false },
        { label: '2023', value: '2023', disabled: false },
      ],
    };
  },
  props: ['roleList1'],

  created() {},
  mounted() {
    this.$nextTick(() => {
      this.updateRoleList();
    });
  },

  methods: {
    moment,
    resetEvent() {},
    insertEvent() {
      const $table = this.$refs.xTable;
      const record = {};
      $table.insert(record);
    },
    formatRole(value, arr) {
      const item = arr.find((item) => item.value === value);
      return item ? item.label : value;
    },
    updateRoleList() {
      const $table = this.$refs.xTable;
      // 获取表格中的全量数据
      const { fullData } = $table.getTableData();
    },
    roleChangeEvent({ row }) {
      this.updateRoleList();
    },
    editActivedEvent({ row }) {
      // 激活编辑时检查剩余选项是否可选择
      this.updateRoleList();
    },
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
